// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/tarifas-cars/list',
    name: 'tarifas-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/Tarifas.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_tarifas_cars',
    },
  },
]

export default formTable
